module.exports = __webpack_public_path__ + "static/media/e49c440c-7653-44ce-96d2-f775947ba9fe.7fc3fef0.svg";